export default {
  'menu.login': '登录',
  'menu.onboarding': '入驻中心',
  'menu.onboarding.applications': '申请列表',
  'menu.village-ops': '村庄运营',
  'menu.village-ops.overview': '吾村仪表盘',
  'menu.village-ops.activities': '活动运营',
  'menu.village-ops.jobs': '招工启事',
  'menu.village-ops.products': '商品运营',
  'menu.village-ops.resolutions': '议事',
  'menu.village-ops.impressions': '吾村印象',
  'menu.village-ops.short-videos': '视频管理',
  'menu.village-ops.product-orders': '商品订单',
  'menu.village-ops.villagers': '村民管理',
  'menu.village-ops.artisans': '匠人管理',
  'menu.village-ops.villager-applications': '入村申请',
  'menu.village-ops.profile': '村庄信息',
  'menu.platform-governance': '平台治理',
  'menu.platform-governance.users': '用户管理',
  'menu.platform-governance.villages': '村庄管理',
  'menu.platform-governance.banners': '广告管理',
  'menu.platform-governance.announcements': '公告管理',
  'menu.platform-governance.system-parameter': '系统参数',
  'menu.platform-governance.category-configs': '分类管理',
  'menu.platform-governance.monitoring-events': '行为日志',
  'menu.platform-governance.sms-messages': '消息中心',
  'menu.platform-governance.help-faq': '常见问题',
  'menu.platform-governance.feedbacks': '反馈管理',
  'menu.platform-governance.content-reports': '举报管理',
  'menu.platform-governance.short-videos': '短视频管理',
  'menu.platform-governance.dictionaries': '系统字典',
  'menu.platform-governance.admin-roles': '角色管理',
  'menu.platform-governance.admin-menus': '菜单配置',
  'menu.platform-governance.admin-permissions': '权限配置',
};
